import React from 'react';
import { ReturnHeaders } from '@src/components/shared/ReturnHeaders';
import { ReturnButtons } from '@src/components/shared/ReturnButtons';
import { useReturnStore } from '@src/stores/returnStore';
import { RETURN_METHOD } from '@src/constants/general';
import PostSelectionItems from '@src/components/shared/items/PostSelectionItems';
import { goToNextStep, goToPreviousStep } from '@src/stores/newFlowStore';
import LORPExpectList from './WhatToExpectList';

const LORPWhatToExpect = () => {
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const lorpLineItems = selectedItems.filter(
    (item) => item.returnMethod === RETURN_METHOD.LORP,
  );
  return (
    <div>
      <ReturnHeaders title="Return pickup next steps" />
      <PostSelectionItems selectedReturnItems={lorpLineItems} />
      <div className="sui-mb-4 sui-mt-8">
        <LORPExpectList />
      </div>
      <ReturnButtons
        proceedBack={goToPreviousStep}
        proceedNext={goToNextStep}
      />
    </div>
  );
};

export default LORPWhatToExpect;
